export default __webpack_public_path__ + "static/media/qr-code.368a527a.jpg";